var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"calendar-date",class:_vm.data.staticClass},[_c('div',[_vm._v(_vm._s(_vm.props.date))]),_c('div',{staticClass:"calendar-date__subtitle"},[_vm._v(_vm._s(_vm.props.month))])])}
var staticRenderFns = []

export { render, staticRenderFns }